export default __webpack_public_path__ + "static/media/bg1.8c2d93da.png";